import { MAIN_API, OFFICE_API } from '../../constants';

// it is worked only in without destructurisation process.env.ASSETS_BUCKET_NAME
const protocol = process.env.NODE_ENV === 'development' ? 'http' : 'https';
export const endpoints = {
  liveURL: {
    pan_vault: `${protocol}://${process.env.PAN_VAULT_URL}`,
    [MAIN_API]: `${protocol}://${process.env.MAIN_API_URL}`,
    [OFFICE_API]: `${protocol}://${process.env.OFFICE_API_URL}`,
    sts_api: `${protocol}://${process.env.STS_API_URL}`,
    aws_s3: `https://${process.env.ASSETS_BUCKET_NAME}.s3.amazonaws.com`,
    aws_s3_accelerate: `https://${process.env.ASSETS_BUCKET_NAME}.s3-accelerate.amazonaws.com`
  },
  sandboxURL: {
    pan_vault: `${protocol}://${process.env.SBX_PAN_VAULT_URL}`,
    [MAIN_API]: `${protocol}://${process.env.SBX_MAIN_API_URL}`,
    [OFFICE_API]: `${protocol}://${process.env.SBX_OFFICE_API_URL}`,
    sts_api: `${protocol}://${process.env.SBX_STS_API_URL}`,
    aws_s3: `https://${process.env.ASSETS_BUCKET_NAME}.s3.amazonaws.com`,
    aws_s3_accelerate: `https://${process.env.ASSETS_BUCKET_NAME}.s3-accelerate.amazonaws.com`
  }
};

export const portalUrls = {
  admin: `${protocol}://${process.env.ADMIN_PORTAL_LEGACY_URL}`,
  portal: `${protocol}://${process.env.MERCHANT_PORTAL_LEGACY_URL}`,
  adminNextgen: `${protocol}://${process.env.ADMIN_PORTAL_URL}`,
  portalNextgen: `${protocol}://${process.env.PORTAL_URL}`,
  receiptsPortal: `${protocol}://${process.env.RECEIPTS_PORTAL_URL}`,
  threeDSApiUrl: `${protocol}://${process.env.THREEDS_URL}`
};

export const urls = {
  website: 'https://www.seamlesspay.com',
  checkout: `${protocol}://${process.env.CHECKOUT_URL}` //Checkout feature is not implemented
};

export const serviceEndpoints = {
  giftCardTransactions: 'merchants/{{merchantId}}/gift-card-transactions'
};

export default endpoints;
